import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./PipelineReceiving.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function PipelineReceiving() {

    useEffect(() => {
    
      trackPageVisit("PipelineReceiving");
    
    }, []);
  
     const {  valves, toggleValve, transmitters, updateTransmitter} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_1101: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1102: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("PipelineReceiving_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1101: { ...DEFAULT_VALVES.FCV_1101, ...parsed.FCV_1101 },
      FCV_1102: { ...DEFAULT_VALVES.FCV_1102, ...parsed.FCV_1102 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PipelineReceiving_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);






const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };





  const xv1101Open = !valves?.XV_1101;
  const xv1102Open = !valves?.XV_1102;
  const xv1103Open = !valves?.XV_1103;


  /* =========================================================
   FIC_1101 FIXED PIPELINE FLOW
========================================================= */

const FIC_1101 =
  xv1101Open
    ? 1.5945
    : 0;


  /* =========================================================
    PT_1101 DCS PRESSURE SIMULATION
    ========================================================= */

    const [PT_1101, setPT_1101] = useState(0.03);

    useEffect(() => {
    const interval = setInterval(() => {
    if (!xv1101Open) {
      setPT_1101(0.03);
      return;
    }
    /*
      Random pressure fluctuation
    */
    const fluctuation =
      (Math.random() * 0.12) - 0.06;
    /*
      Simulated pressure
    */
    const simulatedPressure =
      3.5 + fluctuation;
    setPT_1101(
      Number(simulatedPressure.toFixed(3))
    );
    }, 500);
    return () => clearInterval(interval);
    }, [xv1101Open]);


  /* =========================================================
   TT_1101 DCS REALISTIC FLUCTUATION
  ========================================================= */

  const [TT_1101, setTT_1101] = useState(33);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!xv1101Open) {
        /* Valve closed → ambient stable temp */
        setTT_1101(prev => {
          const noise =
            (Math.random() - 0.5) * 0.08;
          return Number((33 + noise).toFixed(3));
        });
        return;
      }
      /* Valve open → operating temperature fluctuation */
      setTT_1101(prev => {
        const noise =
          (Math.random() - 0.5) * 0.6;
        const drift =
          (37 - prev) * 0.08;
        const next =
          prev + drift + noise;
        return Number(next.toFixed(3));
      });
    }, 500);
    return () => clearInterval(interval);
  }, [xv1101Open]);




  /* =========================================================
   FLOW SPLIT CALCULATION
  ========================================================= */

  const fcv1101Opening =
    Number(valveData?.FCV_1101?.opening || 0)/100;

  const fcv1102Opening =
    Number(valveData?.FCV_1102?.opening || 0)/100;

    /* =========================================================
    FLOW SPLIT WEIGHT
  ========================================================= */

  const totalOpening =

    (xv1102Open ? fcv1101Opening : 0) +

    (xv1103Open ? fcv1102Opening : 0);


  const FIC_1102 =  xv1102Open && totalOpening > 0 ? FIC_1101 * (fcv1101Opening / totalOpening) : 0;

  const FIC_1103 = xv1103Open && totalOpening > 0 ? FIC_1101 * (fcv1102Opening / totalOpening) : 0;

  const FIC_1104 = FIC_1102 + FIC_1103;


/* =========================================================
   FIQ_1101 TOTALIZER
========================================================= */

const [FIQ_1101, setFIQ_1101] = useState(() => {

  return Number(
    localStorage.getItem("FIQ_1101")
  ) || 0;

});

/* =========================================================
   LAST UPDATE TIMESTAMP
========================================================= */

const [lastUpdate, setLastUpdate] = useState(() => {

  return Number(
    localStorage.getItem(
      "PipelineReceiving_lastUpdate"
    )
  ) || Date.now();

});

/* =========================================================
   SAVE LAST FLOW FOR CATCH-UP
========================================================= */

useEffect(() => {

  localStorage.setItem(
    "PipelineReceiving_lastFlow",
    String(FIC_1104)
  );

}, [FIC_1104]);

/* =========================================================
   ELAPSED-TIME CATCH-UP
========================================================= */

useEffect(() => {

  const now = Date.now();

  const savedLastUpdate =
    Number(
      localStorage.getItem(
        "PipelineReceiving_lastUpdate"
      )
    ) || now;

  const savedFlow =
    Number(
      localStorage.getItem(
        "PipelineReceiving_lastFlow"
      )
    ) || 0;

  const elapsedSeconds =
    (now - savedLastUpdate) / 1000;

  if (
    elapsedSeconds > 0 &&
    savedFlow > 0
  ) {

    setFIQ_1101(prev => {

      const missedVolume =
        (savedFlow / 60) *
        elapsedSeconds;

      return prev + missedVolume;

    });

  }

  setLastUpdate(now);

}, []);

/* =========================================================
   LIVE TOTALIZER
========================================================= */

useEffect(() => {

  const interval = setInterval(() => {

    if (FIC_1104 > 0) {

      setFIQ_1101(prev => {

        /*
          FIC_1104 = BPM

          Convert BPM to BBL/sec
        */

        const increment =
          FIC_1104;

        return prev + increment;

      });

      setLastUpdate(Date.now());

    }

  }, 1000);

  return () => clearInterval(interval);

}, [FIC_1104]);

/* =========================================================
   SAVE TOTALIZER + TIMESTAMP
========================================================= */

useEffect(() => {

  localStorage.setItem(
    "FIQ_1101",
    JSON.stringify(FIQ_1101)
  );

  localStorage.setItem(
    "PipelineReceiving_lastUpdate",
    String(lastUpdate)
  );

}, [FIQ_1101, lastUpdate]);

/* =========================================================
   RESET TOTALIZER
========================================================= */

const resetFIQ1101 = () => {

  setFIQ_1101(0);

  localStorage.setItem(
    "FIQ_1101",
    JSON.stringify(0)
  );

  localStorage.setItem(
    "PipelineReceiving_lastUpdate",
    String(Date.now())
  );

};

  const PT_1102 = xv1102Open && xv1103Open ? PT_1101 : 0.03;
  const TT_1102 = xv1102Open && xv1103Open ? TT_1101 : 35;







useEffect(() => {

  localStorage.setItem(
    "PipelineReceiving_lastFlow",
    String(FIC_1104)
  );

}, [FIC_1104]);



useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1104 === FIC_1104 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1104,
    }
  });

}, [FIC_1104, ]);





              /* 🔥 ALARM ENGINE TAGS */
        
                const { evaluateTag } = useContext(AlarmContext);
        
                useEffect(() => {
                  evaluateTag("PT_1102", PT_1102);
                  

                }, [PT_1102, ]);
                





  return (
    <div className="PipelineReceiving-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "245px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 243px",
          zIndex: 10,
        }}
      >
        CRUDE IMPORT VIA PIPELINE
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1101 */}
      <Valve
        className="XV-1101"
        tag="XV_1101"
        x={201}
        y={153}
        isClosed={valves.XV_1101}
        toggle={toggleValve}
      />

      {/* XV-1002 */}
      <Valve
        className="XV-1102"
        tag="XV_1102"
        x={601}
        y={153}
        isClosed={valves.XV_1102}
        toggle={toggleValve}
      />

      {/* XV-1103 */}
      <Valve
        className="XV-1103"
        tag="XV_1103"
        x={604}
        y={283}
        isClosed={valves.XV_1103}
        toggle={toggleValve}
      />

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1101 */}
        <div
            style={{ position: "absolute", left: 660, top: 144}}
            onMouseEnter={() => setHoveredValve("FCV_1101")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1101")}
          >

            {hoveredValve === "FCV_1101" && (
              <div style={tagStyle}>
                FCV_1101
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1101">
                    
          <defs>
            <linearGradient id="metal_1101">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1101)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1101)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


         {/* FCV-1102 */}
        <div
            style={{ position: "absolute", left: 660, top: 274}}
            onMouseEnter={() => setHoveredValve("FCV_1102")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1102")}
          >

            {hoveredValve === "FCV_1102" && (
              <div style={tagStyle}>
                FCV_1102
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1102">
                    
          <defs>
            <linearGradient id="metal_1102">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1102)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1102)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



          {/* ================= MDS FACEPLATE ================= */}

          {showMDS && (
            <MDSFaceplate
              close={() => setShowMDS(false)}
              showBargeSelector={false}
            />
          )}

           

      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1101?.opening || 0)}
        x={681}
        y={189}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1102?.opening || 0)}
        x={681}
        y={319}
      />


      <button
          onClick={resetFIQ1101}
          style={{
            position: "absolute",
            top: "185px",
            left: "1095px",

            padding: "5px 10px",

            background: "#001eff",
            color: "white",

            border: "none",
            borderRadius: "4px",

            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          RESET
        </button>

        <button
          onClick={() => setShowMDS(true)}
          style={{
            position: "absolute",
            top: "300px",
            left: "100px",
            padding: "5px 2px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 1000
          }}
        >
          Crude MDS
        </button>






          <Transmitter
          tag="FIC_1101"
          value={[FIC_1101]}
          x={265}
          y={139}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM IMPORT PIPELINE TO CRUDE CUSTODY TRANSFER"
         />

         <Transmitter
          tag="PT_1101"
          value={[PT_1101]}
          x={465}
          y={139}
          unit="MPa"
          max={3}
          HH={2.6}
          H={2.5}
          L={0.5}
          LL={0.3}
          c="lime"
          description="PRESSURE OF CRUDE FROM IMPORT PIPELINE TO CRUDE CUSTODY TRANSFER"
         />
        
         <Transmitter
          tag="PT_1102"
          value={[PT_1102]}
          x={895}
          y={189}
          unit="MPa"
          max={3}
          HH={2.6}
          H={2.5}
          L={0.5}
          LL={0.3}
          c="lime"
          description="PRESSURE OF CRUDE FROM IMPORT PIPELINE ON CRUDE CUSTODY TRANSFER MAIN LINE TO PIG LAUNCHER"
         />
        
        <Transmitter
          tag="TT_1101"
          value={[TT_1101]}
          x={365}
          y={139}
          unit="°C"
          max={100}
          HH={70}
          H={50}
          L={22}
          LL={20}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM IMPORT PIPELINE TO CRUDE CUSTODY TRANSFER"
         />

        <Transmitter
          tag="TT_1102"
          value={[TT_1102]}
          x={895}
          y={139}
          unit="°C"
          max={100}
          HH={70}
          H={50}
          L={22}
          LL={20}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM IMPORT PIPELINE ON CRUDE CUSTODY TRANSFER MAIN LINE TO PIG LAUNCHER"
         />

         <Transmitter
          tag="FIC_1102"
          value={[FIC_1102]}
          x={765}
          y={139}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM IMPORT PIPELINE ON CRUDE CUSTODY TRANSFER MAIN LINE"
         />

         <Transmitter
          tag="FIC_1103"
          value={[FIC_1103]}
          x={765}
          y={269}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM IMPORT PIPELINE ON CRUDE CUSTODY TRANSFER BYEPASS LINE"
         />

         <Transmitter
          tag="FIC_1104"
          value={[FIC_1104]}
          x={995}
          y={139}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM IMPORT PIPELINE ON CRUDE CUSTODY TRANSFER MAIN LINE TO PIG LAUNCHER"
         />



         <Transmitter
            tag="FIQ_1101"
            value={[FIQ_1101]}
            x={1090}
            y={138}
            unit="BBL"
            max={100000}
            HH={90000}
            H={80000}
            L={0}
            LL={0}
            c="cyan"
            description="IMPORT PIPELINE FLOW TOTALIZER"
          />


    </div>
  );
}

export default PipelineReceiving;